import React from 'react';
import cx from 'clsx';
import { COMPLETE_URL_KEY, NAME_KEY } from '../../utils/specMapping';
import Link from '../Link';
import * as styles from './style.module.scss';
import pdfImage from '../../images/pdf.png';
import * as themeStyles from '../../assets/theme.module.scss';

// Some data key is too long for mobile, so explicitly cut it for mobile
const getHeaderKey = (key) => {
    if (key === '常態絕緣強度(V/0.1 mm))') {
        return '常態絕緣強度';
    }
    return key;
};

const ProductSpecDetailTable = ({
    headers, rows, hasLink = true, specPdfLink = false, showDitto = false,
}) => (
    <>
        {specPdfLink
            ? (
                <a className={cx(themeStyles.dBlock, themeStyles.mb3, themeStyles.floatRight)} href={specPdfLink} target="_blank" rel="noopener noreferrer">
                    <img className="valign" src={pdfImage} alt="" />
                    <span className="valign">下載產品規格表</span>
                </a>
            )
            : null}

        <table className={styles.table}>
            <thead>
                <tr>
                    {Object.keys(headers).map((key) => (
                        <th key={key}>{headers[key]}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map((row) => (
                    <tr key={row[NAME_KEY].value}>
                        {Object.keys(headers).map((key) => {
                            if (showDitto || !row[key].isDitto) {
                                if (key === NAME_KEY) {
                                    return (
                                        <td key={key} data-name={headers[NAME_KEY]} rowSpan={row[key].rowSpan}>
                                            { hasLink
                                                ? <Link to={row[COMPLETE_URL_KEY].value}>{row[NAME_KEY].value}</Link>
                                                : row[NAME_KEY].value}
                                        </td>
                                    );
                                }
                                return (
                                    <td key={key} data-name={getHeaderKey(headers[key])} rowSpan={row[key].rowSpan}>{row[key].value}</td>
                                );
                            }
                            return null;
                        })}
                    </tr>
                ))}
            </tbody>
        </table>
    </>
);

export default ProductSpecDetailTable;
